import { createLogic } from 'redux-logic'
import { map } from 'rxjs/operators'
import * as constants from '../constants'
import User from '@engine/user'

export const getRecentProjects = createLogic({
    type: constants.GET_RECENT_PROJECTS.ACTION,
    processOptions: {
        successType: constants.GET_RECENT_PROJECTS.FULFILLED,
        failType: constants.GET_RECENT_PROJECTS.REJECTED
    },
    process({ http, getState }) {
        const state = getState()
        const createdUserGuid = User.selectors.user.entityUserGuid(state)
        const reqPayload = {
            'queryParams': { createdUserGuid, ...state.comps.comps.recentPagination.queryParams },
            offset: state.comps.comps.recentPagination.offset, limit: state.comps.comps.recentPagination.limit,
            'userId': createdUserGuid
        }

        return http
            .post('/comps/projects/query', reqPayload)
            .pipe(
                map(http.getBody),
            )
    }
})
